var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { defaultFormatNumberToPrecisionOptions, formatNumberToPrecision } from "./format-number-to-precision";
import { includes, isNumber, toNumber } from "lodash";
export var defaultIndicatorResultFormatterOptions = __assign(__assign({}, defaultFormatNumberToPrecisionOptions), {
  includePrefix: true,
  includeSuffix: true,
  valueIfTrue: 'Yes',
  valueIfFalse: 'No',
  trueValues: ['true', '1', 'y', 'yes'],
  falseValues: ['false', '0', 'n', 'no']
});
export var formatIndicatorValue = function (indicator, options) {
  var opts = __assign(__assign({}, defaultIndicatorResultFormatterOptions), options || {});
  if (!indicator.result) {
    console.warn("Result field must be provided inside indicator entity", indicator);
    return opts.valueIfEmpty;
  }
  var precision = indicator.precision,
    _a = indicator.unit,
    unit = _a === void 0 ? {} : _a,
    _b = indicator.result,
    result = _b === void 0 ? {} : _b;
  var value = result.value,
    numericValue = result.numericValue;
  var _c = unit.valueType,
    valueType = _c === void 0 ? {} : _c,
    suffix = unit.suffix,
    prefix = unit.prefix;
  var surroundValue = function (formatedValue) {
    return "".concat(opts.includePrefix && prefix ? prefix : '').concat(formatedValue).concat(opts.includeSuffix && suffix ? suffix : '');
  };
  // console.log(opts, value);
  // first,if the valu is just not provided, return the valueIfEmpty
  if (value === null || value === undefined) {
    // assume we don't want to use prefixes and suffixes for empty values
    return opts.valueIfEmpty;
  }
  if (valueType.name === 'number') {
    return surroundValue(formatNumberToPrecision(numericValue || toNumber(value), precision, opts));
  }
  if (valueType.name === 'boolean') {
    if (includes(opts.trueValues, value.toLowerCase())) {
      return surroundValue(opts.valueIfTrue);
    }
    if (includes(opts.falseValues, value.toLowerCase())) {
      return surroundValue(opts.valueIfFalse);
    }
    return surroundValue(!!value ? opts.valueIfTrue : opts.valueIfFalse);
  }
  // todo, handle date formatting
  // if we reach here, the data may be incomplete, so try to infer if the value is a number?
  if (numericValue || isNumber(value)) {
    return surroundValue(formatNumberToPrecision(numericValue || toNumber(value), precision, opts));
  }
  // finally, just return the value as is
  return surroundValue(value);
};